import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { queryParser } from '@applyft-web/utils';
import { useAppDispatch } from '../store';
import { selectFlow, setShowCookieBanner } from '../store/app';

export const useCookieBanner = (path: string) => {
  const dispatch = useAppDispatch();
  const flow = useSelector(selectFlow);
  const { skip_cookies } = queryParser(window?.location.search);
  const isFlowPage = flow?.indexOf(path.replace('/', '')) >= 0;

  useLayoutEffect(() => {
    dispatch(setShowCookieBanner(skip_cookies !== 'true' && !isFlowPage));
  }, [dispatch, skip_cookies, isFlowPage]);
};
